import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import TaskSkeleton from "./TaskSkeleton";
import Select from "react-select";
import { debounce } from "lodash";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

// Table styling for better header visibility and fit to screen
const tableStyles = `
    #printableTableClubbed {
        font-size: 0.7rem;
        width: 100%;
        table-layout: fixed;
        margin-bottom: 0;
    }
    #printableTableClubbed thead th {
        font-size: 0.65rem;
        padding: 5px 3px;
        white-space: normal;
        word-wrap: break-word;
        font-weight: 600;
        vertical-align: middle;
        line-height: 1.1;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    #printableTableClubbed tbody td {
        font-size: 0.7rem;
        padding: 5px 3px;
        white-space: normal;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .table-responsive {
        overflow-x: visible;
        width: 100%;
    }
    @media (min-width: 1400px) {
        #printableTableClubbed thead th {
            font-size: 0.7rem;
            padding: 6px 4px;
        }
        #printableTableClubbed tbody td {
            font-size: 0.75rem;
            padding: 6px 4px;
        }
    }
`;

// Inject styles
if (typeof document !== 'undefined') {
    const styleSheet = document.createElement("style");
    styleSheet.innerText = tableStyles;
    document.head.appendChild(styleSheet);
}

const isPhotoFilename = (value) =>
    typeof value === "string" && /\.(jpe?g|png|gif|webp|bmp|svg)$/i.test(value.trim());

const studentDisplayName = (task) => {
    const first = isPhotoFilename(task?.first_name) ? "" : (task?.first_name || "").trim();
    const last = isPhotoFilename(task?.last_name) ? "" : (task?.last_name || "").trim();
    return `${first} ${last}`.trim() || "—";
};

export default function ClubbedDue() {
    const { http, user } = AuthUser();
    const location = useLocation();
    const [tasks, setTasks] = useState([]);
    const [date, setDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentStatus, setCurrentStatus] = useState(null);
    const [loginUser, setloginUser] = useState(user.department_id);
    const [devision, setDevision] = useState([]);
    const [subject, setSubjects] = useState([]);
    const [year, setYear] = useState([]);
    const [term, setTerm] = useState([]);
    const [fees, setFeesList] = useState([]);
    const [standard, setstandard] = useState([]);
    const [selclass, setselclass] = useState("");
    const [allStudent, setAllStudent] = useState([]);
    const [selectedStud, setSelectedStudent] = useState("");
    const [selectedClassStud, setselectedClassStud] = useState("100");
    const [selectedDevStud, setselectedDevStud] = useState("");
    const [selectedDevYear, setselectedDevYear] = useState("");
    const [selectedDevStudType, setselectedDevStudType] = useState("");
    const [selectedDevStudAgentType, setselectedDevStudAgentType] = useState("");
    const [selectedDevStudTypeStd, setselectedDevStudTypeStd] = useState("");
    const [selectedFeesStud, setselectedFeesStud] = useState("");
    const [amount, setAmount] = useState("");
    const [dueDate, setDueDate] = useState("");
    const [dueDateEnd, setDueDateEnd] = useState("");
    const [stClass, setStClass] = useState([]);
    const [stDev, setstDev] = useState([]);
    const [stYear, setstYear] = useState([]);
    const [loading, setLoading] = useState(false);
    const [stAgent, setstAgent] = useState([]);
    const [agentTotals, setAgentTotals] = useState({});
    const [agentNames, setAgentNames] = useState({});

    useEffect(() => {
        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setStClass(res.data.data);
        });

        http.get(`/devision`).then((res) => {
            setstDev(res.data.data);
        });

        http.get(`/year`).then((res) => {
            setstYear(res.data.data);
        });

        http.get(`/subject?login_user=${user.id}`).then((res) => {
            setSubjects(res.data.data);
        });

        http.get(`/student_all?company_id=${user.company_id}`).then((res) => {
            setAllStudent(res.data.data);
        });

        http.get(`/agent?company_id=${user.company_id}`).then((res) => {
            setstAgent(res.data.data);
            const agentMap = {};
            res.data.data.forEach(agent => {
                agentMap[agent.id] = agent.name;
            });
            setAgentNames(agentMap);
        });

        http.get(`/devision?login_user=${user.id}`).then((res) => {
            setDevision(res.data.data);
        });

        http.get(`/terms?login_user=${user.id}`).then((res) => {
            setTerm(res.data.data);
        });

        http.get(`/class?company_id=${user.company_id}`).then((res) => {
            setstandard(res.data.data);
        });

        http.get(`/year?login_user=${user.id}`).then((res) => {
            setYear(res.data.data);
        });
    }, []);

    const handleFilter = () => {
        const valueToSet = selectedStud ? selectedStud.value : " ";
        fetchTaskDetails(
            selectedClassStud,
            selectedDevStud,
            dueDate,
            dueDateEnd,
            selectedDevStudType,
            valueToSet,
            selectedDevStudTypeStd,
            selectedDevStudAgentType
        );
    };

    const fetchTaskDetails = (selectedClassStuds, selectedDevStuds, dueDates, dueDateEnds, typePay, student, std_type, agent) => {
        setIsLoading(true);
        let endpoint = `/student_annual_fee_sub_due_grouped?class=${selectedClassStuds}&dev=${selectedDevStuds}&start_date=${dueDates}&end_date=${dueDateEnds}&type=${typePay}&student=${student}&company_id=${user.company_id}&std_type=${std_type}&agent=${agent}`;

        http
            .get(endpoint)
            .then((res) => {
                setIsLoading(false);
                if (Array.isArray(res.data.data)) {
                    setTasks(res.data.data);
                } else {
                    setIsLoading(false);
                    console.error("API response is not an array");
                }
                if (res.data.agent_totals) {
                    setAgentTotals(res.data.agent_totals);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.error("Error fetching tasks:", error);
            });
    };

    const handleSelectChangeClass = (event) => {
        setselectedClassStud(event.target.value);
    };

    const handleSelectChangeDev = (event) => {
        setselectedDevStud(event.target.value);
    };

    const handleSelectChangeStdType = (event) => {
        setselectedDevStudAgentType(event.target.value);
    };

    const handleSelectChangeYear = (event) => {
        setselectedDevYear(event.target.value);
        http.get(`/tution_feeslists?company_id=${user.company_id}&year=${event.target.value}`)
            .then((res) => {
                setFeesList(res.data.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    const handleSelectChangeDevType = (event) => {
        setselectedDevStudType(event.target.value);
    };

    const handleSelectChangeAgentType = (event) => {
        setselectedDevStudAgentType(event.target.value);
    };

    const handleSelectChange = (selectedOption) => {
        setSelectedStudent(selectedOption);
    };

    const options = allStudent.map((user) => ({
        value: user.id,
        label: `${user.adm_no} - ${user.ext_2}${user.ext_3} - ${user.class}${user.section}  - ${user.mobile}`,
    }));

    const handleClearFields = () => {
        window.location.reload();
    };

    const convertToExcel = () => {
        const exportData = tasks.map((task, index) => ({
            'No': index + 1,
            'Adm No': task.admn_no || '',
            'Student Name': studentDisplayName(task),
            'Class': task.class || '',
            'Div': task.dev || '',
            'Type': task.std_type || '',
            'Master': parseFloat(task.total_amount || 0),
            'Paid': parseFloat(task.total_paid || 0),
            'Due': parseFloat(task.total_due || 0),
            'Conslt': task.agent_name || '',
            'Count': task.fee_count || 0
        }));

        // Add totals row at the end
        exportData.push({
            'No': '',
            'Adm No': '',
            'Student Name': 'TOTAL',
            'Class': '',
            'Div': '',
            'Type': '',
            'Master': totalSumMaster,
            'Paid': totalSumPaid,
            'Due': totalSum,
            'Conslt': '',
            'Count': ''
        });

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Clubbed_Due_List");
        XLSX.writeFile(wb, "clubbed_due_list.xlsx");
    };

    const totalSum = tasks.reduce((total, task) => {
        return total + parseFloat(task.total_due || 0);
    }, 0);

    const totalSumPaid = tasks.reduce((total, task) => {
        return total + parseFloat(task.total_paid || 0);
    }, 0);

    const totalSumMaster = tasks.reduce((total, task) => {
        return total + parseFloat(task.total_amount || 0);
    }, 0);

    const calculateDue = (amount, paid) => {
        const due = amount - paid;
        return due;
    };

    const formatNumber = (num) => {
        if (num === null || num === undefined || num === '') return '';
        const numValue = parseFloat(num);
        if (isNaN(numValue)) return '';
        return numValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",").replace(/\.?0+$/, '');
    };

    // Export to PDF
    const convertToPDF = () => {
        const doc = new jsPDF('l', 'mm', 'a4'); // Landscape orientation
        
        // Prepare table headers
        const headers = [
            'No',
            'Adm No',
            'Student Name',
            'Class',
            'Div',
            'Type',
            'Master',
            'Paid',
            'Due',
            'Conslt',
            'Count'
        ];
        
        // Prepare table rows
        const rows = tasks.map((task, index) => [
            (index + 1).toString(),
            task.admn_no || '',
            studentDisplayName(task),
            task.class || '',
            task.dev || '',
            task.std_type || '',
            formatNumber(task.total_amount),
            formatNumber(task.total_paid),
            formatNumber(task.total_due),
            task.agent_name || '',
            (task.fee_count || 0).toString()
        ]);
        
        // Add totals row
        rows.push([
            '',
            '',
            'TOTAL',
            '',
            '',
            '',
            formatNumber(totalSumMaster),
            formatNumber(totalSumPaid),
            formatNumber(totalSum),
            '',
            ''
        ]);
        
        // Add title
        doc.setFontSize(16);
        doc.setFont('helvetica', 'bold');
        doc.text('Clubbed Due Report', doc.internal.pageSize.getWidth() / 2, 12, { align: 'center' });
        
        // Add horizontal line
        doc.setLineWidth(0.5);
        doc.line(14, 16, doc.internal.pageSize.getWidth() - 14, 16);
        
        // Add filter info
        doc.setFontSize(9);
        let filterText = '';
        if (selectedClassStud && selectedClassStud !== '100') filterText += `Class: ${selectedClassStud} `;
        if (selectedDevStud) filterText += `Div: ${selectedDevStud} `;
        if (dueDate) filterText += `From: ${dueDate} `;
        if (dueDateEnd) filterText += `To: ${dueDateEnd}`;
        if (filterText) {
            doc.text(filterText, 14, 21);
        }
        
        // Add generation date
        doc.setFontSize(8);
        doc.text(`Generated on: ${moment().format('DD-MM-YYYY HH:mm')}`, doc.internal.pageSize.getWidth() - 14, 21, { align: 'right' });
        
        // Add table using autoTable
        autoTable(doc, {
            head: [headers],
            body: rows,
            startY: filterText ? 25 : 22,
            theme: 'grid',
            styles: { 
                fontSize: 8,
                cellPadding: 2
            },
            headStyles: {
                fillColor: [41, 128, 185],
                textColor: 255,
                fontStyle: 'bold',
                halign: 'center'
            },
            columnStyles: {
                0: { cellWidth: 10, halign: 'center' },  // No
                1: { cellWidth: 20, halign: 'left' },    // Adm No
                2: { cellWidth: 50, halign: 'left' },    // Name
                3: { cellWidth: 20, halign: 'left' },    // Class
                4: { cellWidth: 12, halign: 'center' },  // Div
                5: { cellWidth: 15, halign: 'center' },  // Type
                6: { cellWidth: 25, halign: 'right' },   // Master
                7: { cellWidth: 25, halign: 'right' },   // Paid
                8: { cellWidth: 25, halign: 'right' },   // Due
                9: { cellWidth: 30, halign: 'left' },    // Conslt
                10: { cellWidth: 15, halign: 'center' }  // Count
            },
            didParseCell: function(data) {
                // Make totals row bold
                if (data.row.index === rows.length - 1) {
                    data.cell.styles.fontStyle = 'bold';
                    data.cell.styles.fillColor = [240, 240, 240];
                }
            },
            didDrawPage: function (data) {
                // Footer with page numbers
                doc.setFontSize(8);
                doc.setTextColor(128);
                const pageCount = doc.internal.getNumberOfPages();
                const pageSize = doc.internal.pageSize;
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                doc.text(
                    `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
                    doc.internal.pageSize.getWidth() / 2,
                    pageHeight - 10,
                    { align: 'center' }
                );
            }
        });
        
        // Save the PDF
        doc.save(`clubbed_due_list_${moment().format('YYYY-MM-DD')}.pdf`);
        toast.success('PDF exported successfully!');
    };

    return (
        <>
            <div className="container-fluid px-0">
                <Toaster position="top-right" reverseOrder={false} />

                <div className="row mt-3 px-4">
                    <div className="col-md-2  text-end">
                        <select onChange={handleSelectChangeClass} className="form-control">
                            <option value="">Select Class</option>
                            <option value="">All</option>
                            {stClass.map((option, index) => (
                                <option key={index} value={option.class_name}>
                                    {option.class_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-1  text-end">
                        <select onChange={handleSelectChangeDev} className="form-control">
                            <option value=""> Div</option>
                            {stDev.map((options, index) => (
                                <option key={index} value={options.name}>
                                    {options.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-1  text-end ">
                        <select onChange={handleSelectChangeYear} className="form-control border border-danger">
                            <option value=""> Year</option>
                            {stYear.map((options, index) => (
                                <option key={index} value={options.name}>
                                    {options.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-2">
                        <input type="date" className="form-control" onChange={(e) => setDueDate(e.target.value)} />
                    </div>
                    <div className="col-md-2">
                        <input type="date" className="form-control" onChange={(e) => setDueDateEnd(e.target.value)}></input>
                    </div>
                    <div className="col-md-4 ">
                        <Select
                            options={options}
                            onChange={handleSelectChange}
                            value={selectedStud}
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-3  text-end">
                        <select onChange={handleSelectChangeStdType} className="form-control">
                            <option value="">Select Type</option>
                            <option value="New">New</option>
                            <option value="Old">Old</option>
                        </select>
                    </div>

                    <div className="col-md-3  text-end">
                        <select onChange={handleSelectChangeDevType} className="form-control">
                            {loading ? (
                                <option>Loading...</option>
                            ) : (
                                <>
                                    <option value="">Fees Type</option>
                                    {fees.map((options, index) => (
                                        <option key={index} value={options.id}>
                                            {options.name}
                                        </option>
                                    ))}
                                </>
                            )}
                        </select>
                    </div>

                    <div className="col-md-2 form-group">
                        <select
                            onChange={handleSelectChangeAgentType}
                            className="form-control"
                        >
                            <option value="">Select Agent</option>
                            {stAgent.map((options, index) => (
                                <option key={index} value={options.name}>
                                    {options.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-1">
                        <Link to="/fees_item" className="btn bt-sm btn-success" onClick={handleClearFields}>
                            Clear
                        </Link>
                    </div>

                    <div className="col-md-1">
                        <button className="btn bt-sm btn-success" onClick={convertToExcel}>
                            Export
                        </button>
                    </div>

                    <div className="col-md-1">
                        <button className="btn bt-sm btn-danger" onClick={convertToPDF}>
                            PDF
                        </button>
                    </div>

                    <div className="col-md-1">
                        <button className="btn bt-sm btn-primary" onClick={handleFilter}>
                            Search
                        </button>
                    </div>
                </div>
                <hr className="mx-4" />
                <div className="row px-4">
                    {isLoading ? (
                        <TaskSkeleton />
                    ) : selectedClassStud == 100 ? (
                        <div className="alert alert-warning" role="alert">
                            Please select a class to filter!
                        </div>
                    ) : (
                        <div className="table-responsive">
                        <table id="printableTableClubbed" className="table table-striped center_tbl mt-2">
                            <thead className="table-primary">
                                <tr>
                                    <th style={{ width: '3%' }}>No</th>
                                    <th style={{ width: '7%' }}>Adm No</th>
                                    <th style={{ width: '15%' }}>Student Name</th>
                                    <th style={{ width: '15%' }}>Class</th>
                                    <th style={{ width: '5%' }}>Div</th>
                                    <th style={{ width: '5%' }}>Type</th>
                                    <th style={{ width: '10%' }}>Master <br />(<b>{formatNumber(totalSumMaster)}</b>)</th>
                                    <th style={{ width: '10%' }}>Paid <br />(<b>{formatNumber(totalSumPaid)}</b>)</th>
                                    <th style={{ width: '10%' }}>Due <br />(<b>{formatNumber(totalSum)}</b>)</th>
                                    <th style={{ width: '8%' }}>Conslt</th>
                                    <th style={{ width: '6%' }}>Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tasks.map((task, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{task.admn_no}</td>
                                        <td>
                                            {studentDisplayName(task)}
                                            {/* <Link
                                                to={`/bill_list/${task.student_id}`}
                                                className="ms-2"
                                                title="View Bills"
                                                style={{ textDecoration: 'none' }}
                                            >
                                                <i className="fas fa-file-invoice-dollar text-info"></i>
                                            </Link> */}
                                        </td>
                                        <td>{task.class}</td>
                                        <td>{task.dev}</td>
                                        <td>{task.std_type}</td>
                                        <td><b>{formatNumber(task.total_amount)}</b></td>
                                        <td><b>{formatNumber(task.total_paid)}</b></td>
                                        <td><b>{formatNumber(task.total_due)}</b></td>
                                        <td><b>{task.agent_name || ""}</b></td>
                                        <td><b>{task.fee_count || 0}</b></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        </div>
                    )}
                </div>
            </div >
        </>
    );
}

